import Breadcrumb from "react-bootstrap/Breadcrumb";
import React from "react";
const CustomBreadcrumb = ({ title }) => {
  return (
    <div className="breadcrumb-container">
      <Breadcrumb className="mb-4">
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item active>{title}</Breadcrumb.Item>
      </Breadcrumb>
    </div>
  );
};

export default CustomBreadcrumb;